<template>
  <div v-if="cartStore.timeLeft" class="flex flex-col rounded text-brand-text gap-2 sm:w-full">
    <span class="text-muted-foreground font-semibold"
      >{{ $t("Ticket reservation remaining:") }}
      <CartTimer />
    </span>
    <div class="h-2 bg-slate-300 w-full rounded-full">
      <div
        class="h-2 bg-success w-full rounded-full transition-all"
        :style="{ width: `${(cartStore.timeLeft / cartStore.reservationTotalTime) * 100}%` }"></div>
    </div>
  </div>
  <Alert v-else-if="!cartStore.items?.length" status="warning">
    {{ $t("There are no items in your shopping cart right now...") }}
  </Alert>
  <div v-else class="flex flex-col gap-2">
    <div class="grow text-foreground">{{ $t("Tickets are no longer reserved.") }}</div>
    <Button @click.prevent="updateReservation('reserve-again')">
      {{ $t("Reserve again for 10 minutes") }}
    </Button>
  </div>
</template>
<script setup>
import CartTimer from "./CartTimer.vue";
import { useCartStore } from "@/store/cart.ts";
import { Alert, Button } from "@xs2event/js-lib/components";

const cartStore = useCartStore();
const updateReservation = async (action) => {
  cartStore.reservationId = null;
  await cartStore.updateReservation(action);
};
</script>
